module.exports = __webpack_public_path__ + "static/media/Sumo1.98eb6683.glb";